// import { axiosPrivate } from "api/axios";
// import { AUTH_TOKEN, REFRESH_TOKEN } from "constants/AuthConstant";

// const ParentService = {};

// ParentService.addParent = function (data) {
 
//   return axiosPrivate({
//     method: "post",
//     url: "/parents",
//     data: data,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };



// ParentService.UpdateParent = function (id, data) {
 
//   return axiosPrivate({
//     method: "put",
//     url: `/parents/${id}`,
//     data: data,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// ParentService.ToggleStatusParent = function (id, data) {

//     return axiosPrivate({
//       method: "put",
//       url: `/parents/toggleParentStatus/${id}`,
//       data: data,
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//       },
//     });
//   };

// ParentService.getParents = function () {
//   return axiosPrivate({
//     method: "get",
//     url: `/parents/allParents`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// ParentService.getOneParent = function (id) {
//   return axiosPrivate({
//     method: "get",
//     url: `/parents/${id}`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };
// ParentService.deleteParent = function (id) {
//   return axiosPrivate({
//     params: {
//       id: id
//     },
//     method: "delete",
//     url: `/parents`,
    
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };
// ParentService.toggleStatus = function (id, data) {
//   return axiosPrivate({
//     method: "put",
//     url: `/parents/toggleParentStatus/${id}`,
//     data: data,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };




// export default ParentService;




import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const ParentService = {};

ParentService.addParent = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/parents",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.UpdateParent = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/parents/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.ToggleStatusParent = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/parents/toggleParentStatus/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.getParents = function () {
  return axiosPrivate({
    method: "get",
    url: `/parents/allParents`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.getOneParent = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/parents/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.deleteParent = function (id) {
  return axiosPrivate({
    params: {
      id: id,
    },
    method: "delete",
    url: `/parents`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ParentService.toggleStatus = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/parents/toggleParentStatus/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default ParentService;